<template>
    <b-btn
        :variant="variant"
        :size="size"
        :disabled="disabled || loading"
        class="d-inline-flex align-items-center"
        @click="$emit('click')"
    >
        <slot />
        <Spinner
            v-if="loading"
            :variant="variant"
            :size="loadingSize"
            class="d-inline-block"
            :class="spinnerPadding"
        />
    </b-btn>
</template>

<script>
export default {

    props: {
        variant: {
            type: String,
            default: 'primary',
        },
        size: {
            type: String,
            default: 'md',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingSize: {
            type: String,
            default: 'tiny',
        },
    },

    computed: {
        spinnerPadding() {
            if (this.size === 'sm') {
                return 'ml-1';
            }
            if (this.size === 'md') {
                return 'ml-2';
            }
            return '';
        },
    },

};
</script>
